<div class="video-hero">
  <div class="noise"></div>
  <div class="matte"></div>
  <div id="popcorn" class="vimeo-wrapper"></div>
</div>
